<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PageHeader from '@/components/layout/PageHeader.vue'
import PageFooter from '@/components/layout/PageFooter.vue'
import SignInPrompt from '@/components/auth/SignInPrompt.vue'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const auth = useAuthStore()

// Pages opt in with `meta: { requiresAuth: true }` in the router
const needsAuth = computed(() => route.meta.requiresAuth === true)

// The fantasy page carries its own header (the league hero) and its data
// is fully public — nothing there uses the global bar's home link or
// Google sign-in (only /upload is auth-gated) — so the bar is hidden on
// /fantasy only. Every other route keeps it exactly as-is.
const showHeader = computed(() => route.path !== '/fantasy')
</script>

<template>
  <div class="app">
    <PageHeader v-if="showHeader" />
    <main class="main-content">
      <p v-if="needsAuth && auth.loading" class="auth-loading">Loading...</p>
      <SignInPrompt v-else-if="needsAuth && !auth.isLoggedIn" />
      <RouterView v-else />
    </main>
    <PageFooter />
  </div>
</template>

<style scoped>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

.auth-loading {
  text-align: center;
  color: #666;
  padding: 3rem 1rem;
}
</style>
